import Vue from 'vue'
import { storeEntities } from './helpers'
import toast from '../../services/toast'
import _cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export default {
  state: {
    attendances: {
      studentIds: [],
    },
    students: {},
    unexpectedStudentIds: {},
    contexts: {},
    contextLabels: {},
    courseId: null,
    lessonId: null,
    loadingClick: false,
    lastSaved: '',
    registrationAvailable: false,
    lesson: null,
  },
  mutations: {
    // Registration
    CHANGE_LOADING (state, loading) {
      state.loadingClick = loading
    },
    CHANGE_LAST_SAVED (state, lastSaved) {
      state.lastSaved = lastSaved
    },
    SET_COURSE (state, courseId) {
      state.courseId = courseId
    },
    SET_LESSON (state, lessonId) {
      state.lessonId = lessonId
    },
    SET_CONTEXT_LABELS (state, contextLabels) {
      state.contextLabels = contextLabels
    },
    SET_MINUTES_MISSING_CONFIG (state, config) {
      state.minutesMissingConfig = config
    },
    ADD_ATTENDANCES (state, attendances) {
      Vue.set(state.attendances, 'studentIds', attendances)
    },
    ADD_UNEXPECTED_STUDENT_IDS (state, unexpectedStudentIds) {
      Vue.set(state.unexpectedStudentIds, 'studentIds', unexpectedStudentIds)
    },
    ADD_LESSON_DATA (state, data) {
      state.lesson = data
    },
    NEW_UNEXPECTED_STUDENT_ID (state, studentId) {
      state.unexpectedStudentIds.studentIds.push(String(studentId))
    },
    NEW_ATTENDANCE (state, studentId) {
      state.attendances.studentIds.push(String(studentId))
    },
    DELETE_ATTENDANCE (state, indexStudent) {
      state.attendances.studentIds.splice(indexStudent, 1)
    },
    ADD_STUDENTS (state, students) {
      storeEntities(students, state.students)
    },
    ADD_CONTEXTS (state, contexts) {
      storeEntities(contexts, state.contexts)
    },
    DELETE_CONTEXT (state, contextIndex) {
      Vue.delete(state.contexts, contextIndex)
    },
    CHANGE_REGISTRATION_STATE (state, registrationState) {
      state.registrationAvailable = (registrationState === true || registrationState === 1)
    },
    CLEAR_ATTENDANCE_LIST_STATE (state) {
      state.attendances = {}
      state.students = {}
      state.unexpectedStudentIds = {}
      state.contexts = {}
      state.contextLabels = {}
      state.loadingClick = false
      state.lastSaved = ''
      state.registrationAvailable = false
      state.lesson = null
    },
  },
  actions: {
    change_loading ({ commit, state }, { loading }) {
      commit('CHANGE_LOADING', loading)
      if (!loading) {
        if (state.courseId === null) {
          commit('CHANGE_LAST_SAVED', '')
        } else {
          const time = moment().format('HH:mm')
          commit('CHANGE_LAST_SAVED', time)
        }
      }
    },
    set_enable_attendance_list ({ commit, state }, { registrationEnabled }) {
      commit('CHANGE_REGISTRATION_STATE', registrationEnabled)
    },
    set_course_and_lesson ({ commit, state }, { courseId, lessonId, registrationEnabled }) {
      commit('SET_COURSE', courseId)
      commit('SET_LESSON', lessonId)
      commit('CHANGE_REGISTRATION_STATE', registrationEnabled)
    },
    set_context_labels ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/api-context-labels`).then(({ data }) => {
        commit('SET_CONTEXT_LABELS', data)
      })
    },
    set_minutes_missing_config ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/api-minutes-missing-config`).then(({ data }) => {
        commit('SET_MINUTES_MISSING_CONFIG', data)
      })
    },
    get_student_data ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/api`).then(({ data }) => {
        commit('ADD_STUDENTS', data.newStudentData.original.data)
        commit('ADD_CONTEXTS', data.newStudentData.original.included)
        commit('ADD_UNEXPECTED_STUDENT_IDS', data.unexpectedStudentIds)
      })
    },
    get_lesson_data ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list-details`).then(({ data }) => {
        commit('ADD_LESSON_DATA', data)
        return data
      })
    },
    get_attendance_data ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/api-attended-student-ids`).then(({ data }) => {
        const studentIds = data.studentIds.map(String)
        commit('ADD_ATTENDANCES', studentIds)
      })
    },
    change_attendance ({ commit, state }, { courseId, lessonId, studentIds, attended, unexpected }) {
      const postData = {
        studentIds,
        attended,
        unexpected,
        contextLabels: state.contextLabels.settableContexts,
        unexpectedStudentIds: state.unexpectedStudentIds.studentIds,
      }
      return axios.post(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list`, postData).then((response) => {
        commit('ADD_UNEXPECTED_STUDENT_IDS', response.data.unexpectedStudentIds)
        const newStudentIds = response.data.newStudentIds
        if (response.data.newAttended) {
          commit('ADD_STUDENTS', response.data.newStudentData.original.data)
          commit('ADD_CONTEXTS', response.data.newStudentData.original.included)
          newStudentIds.forEach(id => {
            const studentIndex = state.attendances.studentIds.indexOf(String(id))
            if (studentIndex === -1) {
              commit('NEW_ATTENDANCE', id)
            }
          })
        } else {
          newStudentIds.forEach((id) => {
            const studentIndex = state.attendances.studentIds.indexOf(String(id))
            if (studentIndex > -1) {
              commit('DELETE_ATTENDANCE', studentIndex)
            }
          })
        }
      })
    },
    echo_attendances ({ commit, state }, { studentIds }) {
      const postData = {
        studentIds,
        attendanceIds: state.attendances.studentIds,
        contextLabels: state.contextLabels.settableContexts,
        unexpectedStudentIds: state.unexpectedStudentIds.studentIds,
      }
      return axios.post(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/echo`, postData).then((response) => {
        commit('ADD_STUDENTS', response.data.newStudentData.original.data)
        commit('ADD_CONTEXTS', response.data.newStudentData.original.included)
        const studentIds = response.data.attendances.map(String)
        commit('ADD_ATTENDANCES', studentIds)
      })
    },
    change_context ({ commit, state }, { courseId, lessonId, studentId, contextType, checked, remark }) {
      const postData = {
        studentId,
        contextType,
        checked,
        remark,
        contextLabels: state.contextLabels.settableContexts,
        unexpectedStudentIds: state.unexpectedStudentIds.studentIds,
      }
      return axios.post(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/context`, postData).then((response) => {
        commit('ADD_STUDENTS', [response.data.newData.original.data])
        if (response.data.newChecked) {
          commit('ADD_CONTEXTS', response.data.newData.original.included)
        } else {
          commit('DELETE_CONTEXT', response.data.contextId)
        }
      })
    },

    suggest_new_student ({ commit, state }, { courseId, lessonId, postData }) {
      return axios.post(postData.url, postData.params)
    },

    new_student ({ commit, state }, { courseId, lessonId, postData }) {
      return axios.post(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/create-student`, postData, { errorHandle: false }).then((response) => {
        commit('NEW_UNEXPECTED_STUDENT_ID', [response.data.data.newStudentData.original.data[0].id])
        commit('ADD_STUDENTS', response.data.data.newStudentData.original.data)
        commit('NEW_ATTENDANCE', [response.data.data.newStudentData.original.data[0].id])
      })
    },

    close_key ({ commit, state }) {
      return axios.put(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendance-list/close-key`).then((response) => {
        window.location.href = response.data.redirect
      })
    },

    confirm_attendances ({ commit, state }) {
      return axios.get(`/employee/courses/${state.courseId}/lessons/${state.lessonId}/attendances/verify`).then((response) => {
        window.location.href = response.data.redirect
      })
    },

    clear_attendance_list_state ({ commit, state }) {
      commit('CLEAR_ATTENDANCE_LIST_STATE')
    },
  },
}
